import React, { PureComponent } from 'react'
import classNames from 'classnames'
import {
  bool, string, func, shape, arrayOf,
} from 'prop-types'
import Button from '@active/react-ui/Button'
import Link from '@active/react-ui/Link'
import prop from 'lodash/fp/prop'
import find from 'lodash/find'

import Identity from '@active/react-utils/components/Identity'
import { withI18n } from '@active/react-utils/i18n'
import appendQuery from 'append-query'
import DefaultComponentLayout, { LayoutContent } from '../common/Layout'
import SigninForm from './components/SigninForm'
import PasswordUpdater from './components/PasswordUpdater'
import ReagreeWaiver from './components/ReagreeWaiver'
import ReagreeWaiverConfirm from './components/ReagreeWaiverConfirm'
import GrantPermission from './components/GrantPermission'
import CountryChoose from './components/CountryChoose'
import Verification from './components/Verification'
import MFAV2ByStep from '../generalSigninUp/MFAV2/MFAV2ByStep'
import { noop, merge } from '../../shared/utils/commonUtils'
import { FacebookCreateAccount, FacebookBindAccount } from '../common/Facebook'
import CoppaEmailInput from '../common/CoppaEmailInput'
import PhoneAuthenticationByStep from './components/PhoneAuthentication/PhoneAuthenticationByStep'
import withKeycloak from '../../shared/utils/withKeycloak'
import SigninWithContent from './components/SigninWithContent'
import ReviewProfileModal from './components/ReviewProfileModal'
import LinkAccount from './components/LinkAccount'
import { show as showSpinner, hide as hideSpinner } from '../../shared/utils/spinnerUtils'
import { mfaConfig } from '../common/MFAByStep'

import './Signin.scss'
import I18nMessage from '../common/I18nMessage'
import connectLocale from '../../shared/utils/connectLocale'

const STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PSW_NOT_QUALFIED: 'PSW_NOT_QUALFIED',
  NO_COUNTRY_CODE: 'NO_COUNTRY_CODE',
  WAIVER_EXPIRED: 'WAIVER_EXPIRED',
  PERMISSION_FAIL: 'PERMISSION_FAIL',
  COPPA: 'COPPA',
  NEED_PERMISSION: 'NEED_PERMISSION',
  OTP_INITED: 'OTP_INITED', // TODO: Remove MFAV1
  MFA_INITED: 'MFA_INITED',
  PHONE_SETUP_INITED: 'PHONE_SETUP_INITED',
  REVIEW_PROFILE_INITED: 'REVIEW_PROFILE_INITED',
  IDP_LOGIN_INITED: 'IDP_LOGIN_INITED',
  PASSWORD_EXPIRED: 'PASSWORD_EXPIRED',
}

function handlePasswordUpdate({ code, message }, nextState) {
  return ({
    ...nextState,
    isPasswordUpdaterShow: true,
    passwordUpdaterResult: {
      code, message,
    },
  })
}

function handlePasswordUpdated(result, newPswd, nextState) {
  let pswdOb = {}
  if (newPswd) {
    pswdOb = { pawd: newPswd }
  }
  const _fields = { ...nextState.fields, ...result.fields, ...pswdOb }
  return { ...nextState, ...result, fields: _fields }
}

function handleShowCoppaEmail(showCoppaEmailInput, pendingKey, nextState) {
  return ({
    ...nextState,
    coppaEmailResult: {
      showCoppaEmailInput,
      pendingKey,
      forceV4: true,
    },
  })
}

class Signin extends PureComponent {
  static propTypes = {
    locale: string.isRequired,
    i18n: func.isRequired,
    authType: string,
    services: shape({
      getCurrentUserName: func.isRequired,
      userSignin: func.isRequired,
    }).isRequired,
    actions: shape({
      signinSuccessCallback: func,
      keycloakSigninCallback: func,
      signinFailCallback: func,
    }),
    countryCodes: string,
    clientConfig: shape({
      suppressActiveWaiver: bool,
      useCustomizeWaiver: bool,
      waiverAttachementObjectIds: string,
      signinOptions: arrayOf(shape({})),
    }),
    customPanelUrl: string,
    processes: shape({
      signIn: func.isRequired,
      signUp: func,
      forgotPassword: func.isRequired,
    }).isRequired,
    goBack: func,
    FacebookBtn: shape({}).isRequired,
    configureTrack: func.isRequired,
    existingAccount: bool,
    Header: func,
    sentEmailGoBack: func,
    username: string,
    prepopulateUsername: string,
    authWithKeycloak: bool,
    keycloakInitialized: bool,
    alreadySignIn: bool,
    onKeycloakSubmit: func,
    initKeycloak: func,
    initError: string,
    messageType: string,
    isPage: bool,
    handleSocialClick: func,
    keycloak: shape({}),
    signinOptions: arrayOf(shape({})), // for page
    renderModel: string,
    goSignUp: string,

    usernameReadonly: string,
    // For signup via external client
    isGrantPermissionShow: bool,
    clientName: string,
    noRegist: string,
    appendClassToKeycloak: func,
    removeClassToKeycloak: func,
  }

  static defaultProps = {
    username: '',
    prepopulateUsername: '',
    sentEmailGoBack: undefined,
    existingAccount: false,
    Header: null,
    goBack: noop,
    countryCodes: '',
    actions: {
      signinSuccessCallback: undefined,
      keycloakSigninCallback: undefined,
      signinFailCallback: undefined,
    },
    authType: '',
    authWithKeycloak: false,
    onKeycloakSubmit: null,
    initKeycloak: noop,
    keycloakInitialized: false,
    alreadySignIn: false,
    initError: null,
    messageType: null,
    isPage: false,
    handleSocialClick: noop,
    keycloak: null,
    clientConfig: {},
    signinOptions: undefined,
    renderModel: undefined,
    goSignUp: '',

    usernameReadonly: '',

    isGrantPermissionShow: false,
    clientName: '',
    customPanelUrl: '',
    noRegist: 'false',
    appendClassToKeycloak: undefined,
    removeClassToKeycloak: undefined,
  }

  closeModals = {
    isPasswordUpdaterShow: false,
    isCountryChooseShow: false,
    isGrantPermissionShow: false,
    isReagreeWaiverShow: false,
    isReagreeWaiverConfirmShow: false,
    isVerificationShow: false, // TODO: Remove MFAV1
    isShowMFAV2: false,
    isPhoneAuthenticationShow: false,
    isReviewProfileShow: false,
    isLinkAccountShow: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      idpValues: {},
      coppaEmailResult: {},
      passwordUpdaterResult: {
        code: null,
        message: null,
      },
      isPasswordUpdaterShow: false,
      isCountryChooseShow: false,
      isGrantPermissionShow: props.isGrantPermissionShow,
      isReagreeWaiverShow: false,
      isReagreeWaiverConfirmShow: false,
      isVerificationShow: false,
      isShowMFAV2: false,
      isPhoneAuthenticationShow: false,
      isReviewProfileShow: false,
      isLinkAccountShow: false,
      isBack: false,
      resetAgrees: false,
      showError: false,
      clientName: props.clientName,
      errorMsg: '',
      accountCountryCode: '',
      fields: { accountname: props.username },
      nextTimeWindow: '',
      senderPhone: '',
      channel: '',
      otpSendCodeError: '',
      newUserName: undefined,
    }
  }

  componentDidMount() {
    const {
      username,
      prepopulateUsername,
      renderModel,
      services: { getCurrentUserName },
      configureTrack,
      processes: { signUp },
      goSignUp,
      initKeycloak,
      customPanelUrl,
      appendClassToKeycloak,
    } = this.props

    const isShowRightSlotIframe = !!customPanelUrl
    if (isShowRightSlotIframe && appendClassToKeycloak) {
      appendClassToKeycloak('passport-ui-keycloak-custom')
    }

    if (goSignUp === 'true') {
      this.goV5Signup()
    }
    const isPageModel = renderModel === 'PAGE_RENDER'
    configureTrack({
      version: 'v5',
      pageType: 'sign in',
      widget: isPageModel ? '' : 'signIn',
    })
    if (!username && prepopulateUsername === 'true') {
      getCurrentUserName({
        resolve: account => this.setState({ account: JSON.stringify(account) === '{}' ? '' : account }),
      })
    }
    initKeycloak(this.onUserSigninDone)
  }

  componentWillUnmount() {
    if (this.countryChooseTimer) {
      clearTimeout(this.countryChooseTimer)
    }
    if (this.reagreeWaiverTimer) {
      clearTimeout(this.reagreeWaiverTimer)
    }
    if (this.reagreeWaiverConfirmTimer) {
      clearTimeout(this.reagreeWaiverConfirmTimer)
    }

    const { customPanelUrl, removeClassToKeycloak } = this.props
    const isShowRightSlotIframe = !!customPanelUrl
    if (isShowRightSlotIframe && removeClassToKeycloak) {
      removeClassToKeycloak('passport-ui-keycloak-custom')
    }
  }

  onUserSigninDone = (prevState, values, newPswd) => ({
    status, loginURL, message, pendingKey, accountCountryCode, clientName,
    code, // error code during update password
    authorizationCode,
    idpData, // For idp review profile and idp signin
    keycloakRedirectUri, // For application call token API
    kcMessageType, kcErrorMessage, // For keycloak message
    identityProviderAlias, // For link account title
    username, // From w_login_otp LOA case
    isResetTokenSend,
    ...rest
  }) => {
    const {
      configureTrack,
      actions: {
        signinSuccessCallback,
      },
      keycloak,
    } = this.props
    let nextState = { ...prevState, ...this.closeModals }

    if (status === STATUS.SUCCESS) {
      configureTrack({
        eventName: 'SignInConfirmation',
        widget: 'signin',
        pageType: 'sign in',
        explicitName: 'sign in confirmation',
        eventTracking: 'active connect',
      })
      if (signinSuccessCallback) {
        signinSuccessCallback(authorizationCode ? { authorizationCode, keycloak, keycloakRedirectUri } : {
          email: values.accountname, loginURL, pendingKey, accountCountryCode, clientName, ...rest,
        })
      } else {
        window.location.href = loginURL
      }
    } else if (status === STATUS.PSW_NOT_QUALFIED) {
      nextState = handlePasswordUpdate({ code, message }, nextState)
    } else if (status === STATUS.NO_COUNTRY_CODE) {
      nextState = handlePasswordUpdated({
        isCountryChooseShow: true,
        accountCountryCode: '',
      }, newPswd, nextState)
    } else if (status === STATUS.WAIVER_EXPIRED) {
      nextState = this.handleWaiverExpired({
        resetAgrees: true,
        isReagreeWaiverShow: true,
        accountCountryCode: accountCountryCode,
      }, values.isCountryChooseSubmit, newPswd, nextState)
    } else if (status === STATUS.COPPA) {
      nextState = handleShowCoppaEmail(true, pendingKey, nextState)
    } else if (status === STATUS.NEED_PERMISSION) {
      nextState = handlePasswordUpdated({
        isGrantPermissionShow: true,
        clientName,
      }, newPswd, nextState)
    } else if (status === STATUS.PERMISSION_FAIL) {
      nextState = merge(nextState, {
        errorMsg: 'passport.permission.granting.fail',
        showError: true,
        fields: { pawd: '' },
      })
      configureTrack({
        eventName: 'SignInError',
        widget: 'signin',
        pageType: 'sign in',
        explicitName: 'sign in error PERMISSION_FAIL',
      })
    } else if (status === STATUS.OTP_INITED) {
      nextState = merge(nextState, {
        isVerificationShow: true,
        nextTimeWindow: prop('nextTimeWindow')(rest),
        senderPhone: prop('senderPhone')(rest),
        epid: prop('epid')(rest),
        channel: prop('channel')(rest),
        otpSendCodeError: message,
        newUserName: username,
      })
    } else if (status === STATUS.MFA_INITED) {
      nextState = merge(nextState, {
        isShowMFAV2: true,
        mfaMessageType: prop('messageType')(rest),
        mfaMessageContent: prop('messageContent')(rest) || message,
        newUserName: username,
        senderPhone: prop('senderPhone')(rest),
        isTrustDevice: prop('isTrustDevice')(rest),
        nextTimeWindow: prop('nextTimeWindow')(rest),
        stepMode: prop('stepMode')(rest),
        defaultWayForMfaStepOne: prop('defaultWay')(rest),
        channel: prop('channel')(rest),
        isShowBackBtnForMfaStepTwo: prop('isShowBackBtn')(rest),
      })
    } else if (status === STATUS.PHONE_SETUP_INITED) {
      nextState = merge(nextState, {
        isPhoneAuthenticationShow: true,
        epid: prop('epid')(rest),
        stepMode: prop('stepMode')(rest),
        senderPhone: prop('senderPhone')(rest),
        nextTimeWindow: prop('nextTimeWindow')(rest),
      })
    } else if (status === STATUS.REVIEW_PROFILE_INITED) {
      nextState = merge(nextState, {
        isReviewProfileShow: true,
        idpValues: {
          ...idpData,
        },
        kcMessageType,
        kcErrorMessage,
      })
    } else if (status === STATUS.IDP_LOGIN_INITED) {
      nextState = merge(nextState, {
        isLinkAccountShow: true,
        identityProviderAlias,
        idpValues: {
          ...idpData,
        },
        kcMessageType,
        kcErrorMessage,
      })
    } else if (status === STATUS.PASSWORD_EXPIRED) {
      this.handlePasswordExpired({ isResetTokenSend, username })
    } else {
      nextState = merge(nextState, {
        errorMsg: message,
        showError: true,
        fields: { pawd: '' },
      })
      configureTrack({
        eventName: 'SignInError',
        widget: 'signin',
        pageType: 'sign in',
        explicitName: 'sign in error',
      })
    }

    this.setState(nextState)
  }

  onUserSigninFailed = nextState => ({ message, status }) => {
    const closeState = { ...this.closeModals }
    this.setState(merge(closeState, nextState, {
      errorMsg: message,
      showError: true,
      fields: { pawd: '' },
    }), () => {
      // Handle Re-Signin (with or not different accounts)
      // after authenticated failed with non-first authenticator (such as MFA)
      const { isVerificationShow } = this.state
      if (status === STATUS.FAILED && !isVerificationShow) {
        const { initKeycloak } = this.props
        initKeycloak(this.onUserSigninDone)
      }
    })
  }

  onIdpSignin = ({ clickEvent, name }) => {
    const { handleSocialClick } = this.props

    return handleSocialClick(
      eventData => {
        if (eventData.status === STATUS.FAILED) {
          this.onUserSigninFailed(this.state)(eventData)
        } else {
          this.onUserSigninDone(this.state, {}, null)(eventData)
        }
      },
    )({ clickEvent, name })
  }

  setSwitchConfig = newState => {
    this.setState({
      facebookCreateAccountConfig: null,
      facebookBindAccountConfig: null,
      ...newState,
    })
  }

  handleSubmit = async (values, { newPswd } = {}) => {
    this.setState({
      showError: false, errorMsg: null,
    })
    const { remember } = this.state
    const {
      locale, authType, services,
      countryCodes, clientConfig: { suppressActiveWaiver, useCustomizeWaiver, waiverAttachementObjectIds },
      authWithKeycloak, onKeycloakSubmit, actions: { keycloakSigninCallback },
    } = this.props
    const nextState = { fields: { ...values } }
    const params = {
      ...values,
      username: values.accountname,
      locale,
      authType,
      countriesInfo: countryCodes,
      suppressActiveWaiver,
      useCustomizeWaiver,
      waiverAttachementObjectIds,
      newPswd,
    }
    params.password = params.pawd
    delete params.pawd
    if (remember && remember !== 'false') {
      Object.assign(params, { remember: true })
    }

    if (keycloakSigninCallback) {
      showSpinner()
      keycloakSigninCallback(params)
    } else if (authWithKeycloak) {
      const result = await onKeycloakSubmit(params)
      const { status } = result
      if (status === STATUS.FAILED) {
        this.onUserSigninFailed(nextState)(result)
      } else {
        this.onUserSigninDone(nextState, values, newPswd)(result)
      }
    } else {
      services.userSignin({
        params,
        resolve: this.onUserSigninDone(nextState, values, newPswd),
        reject: this.onUserSigninFailed(nextState),
      })
    }
  }

  // Only for Keycloak
  handleIdpSubmit = async params => {
    const { authWithKeycloak, onKeycloakSubmit, actions: { keycloakSigninCallback } } = this.props

    if (keycloakSigninCallback) {
      showSpinner()
      keycloakSigninCallback(params)
    } else if (authWithKeycloak) {
      const result = await onKeycloakSubmit(params)
      const { status } = result
      if (status === STATUS.FAILED) {
        this.onUserSigninFailed({})(result)
      } else {
        this.onUserSigninDone({}, {})(result)
      }
    }
  }

  cleanState = () => {
    this.setState({
      kcMessageType: '',
      kcErrorMessage: '',
    })
  }

  handleWaiverExpired = (result, isCountryChooseSubmit, newPswd, nextState) => {
    const { authWithKeycloak } = this.props
    const _result = { ...result }
    _result.isBack = !authWithKeycloak && !!isCountryChooseSubmit
    return handlePasswordUpdated(_result, newPswd, nextState)
  }

  handlePasswordUpdaterModalClose = () => {
    this.setState({
      isPasswordUpdaterShow: false,
      passwordUpdaterResult: {},
    })
    const { initKeycloak } = this.props
    initKeycloak(this.onUserSigninDone)
  }

  handleVerificationClose = () => {
    this.setState({
      isVerificationShow: false,
    })
    const { initKeycloak } = this.props
    initKeycloak(this.onUserSigninDone)
  }

  handleVerificationRequestCode = values => {
    const { onKeycloakSubmit } = this.props

    return new Promise(resolve => {
      onKeycloakSubmit(values).then(result => {
        const { status, nextTimeWindow, message } = result
        this.setState({ nextTimeWindow: nextTimeWindow })

        if (status === STATUS.FAILED) {
          resolve({ message })
        } else {
          resolve({})
        }
      })
    })
  }

  handleVerificationVerify = values => {
    const {
      onKeycloakSubmit,
      clientConfig: {
        suppressActiveWaiver,
        useCustomizeWaiver,
        waiverAttachementObjectIds,
      },
      countryCodes: countriesInfo,
    } = this.props

    const { fields: { accountname, pawd } } = this.state

    return new Promise(resolve => {
      onKeycloakSubmit({
        ...values,
        suppressActiveWaiver,
        useCustomizeWaiver,
        waiverAttachementObjectIds,
        countriesInfo,
        needReCOPPA: true,
        needAccountCountry: true,
        password: pawd,
      }).then(result => {
        const {
          status, message, errorCode, operation,
        } = result
        if (status === STATUS.FAILED) {
          resolve({ message, errorCode })
        } else {
          resolve(result)
          if (operation === 'PHONE_SETUP_SEND' && status === STATUS.SUCCESS) { // handle count down just in front end and get code from mobile

          } else {
            this.onUserSigninDone(this.state, { accountname, pawd })(result)
          }
        }
      })
    })
  }

  handleSetUpPhone = values => {
    showSpinner()
    const {
      onKeycloakSubmit,
      clientConfig: {
        suppressActiveWaiver,
        useCustomizeWaiver,
        waiverAttachementObjectIds,
      },
      countryCodes: countriesInfo,
    } = this.props

    const { fields: { accountname, pawd } } = this.state

    return new Promise(resolve => {
      onKeycloakSubmit({
        ...values,
        suppressActiveWaiver,
        useCustomizeWaiver,
        waiverAttachementObjectIds,
        countriesInfo,
        needReCOPPA: true,
        needAccountCountry: true,
        password: pawd,
      }).then(result => {
        const {
          status, message, errorCode, ...rest
        } = result
        if (status === STATUS.FAILED) {
          resolve({ message, errorCode })
        } else {
          resolve(rest)
          this.onUserSigninDone(this.state, { accountname, pawd })(result)
        }
      })
    }).finally(() => {
      hideSpinner()
    })
  }

  handlePasswordUpdaterSubmit = ({ newPswd }) => {
    const { fields: { accountname, pawd } } = this.state
    this.setState({
      isPasswordUpdaterShow: false,
    })
    this.handleSubmit({
      accountname,
      pawd,
    }, { newPswd })
  }

  handleChangeCountry = value => {
    this.setState({
      selectedCountryCode: value,
    })
  }

  handleCountryChooseModalClose = () => {
    this.setState({
      isCountryChooseShow: false,
    })
    const { initKeycloak } = this.props
    initKeycloak(this.onUserSigninDone)
  }

  handleCountryChooseSubmit = () => {
    const { fields: { accountname, pawd }, selectedCountryCode } = this.state
    this.setState({
      isCountryChooseShow: false,
    })
    this.handleSubmit({
      accountname,
      pawd,
      selectedCountryCode,
      isCountryChooseSubmit: true,
    })
  }

  handleReagreeWaiverClose = () => {
    this.setState({
      isReagreeWaiverShow: false,
    }, () => {
      this.reagreeWaiverConfirmTimer = setTimeout(() => {
        this.setState({
          isReagreeWaiverConfirmShow: true,
        })
      }, 500)
    })
  }

  handleReagreeWaiverSubmit = values => {
    const { fields: { accountname, pawd } } = this.state
    this.handleSubmit({
      ...values,
      accountname,
      pawd,
      reagree: true,
    })
  }

  handleIdpModalCloseBuilder = stepId => () => {
    this.setState({
      [stepId]: false,
    })
    const { initKeycloak } = this.props
    initKeycloak(this.onUserSigninDone)
  }

  handleBack = () => {
    this.setState({
      isReagreeWaiverShow: false,
    }, () => {
      this.countryChooseTimer = setTimeout(() => {
        this.setState({
          isCountryChooseShow: true,
        })
      }, 500)
    })
  }

  handleReagreeWaiverCheckboxChange = () => {
    this.setState({
      resetAgrees: false,
    })
  }

  handleReagreeWaiverConfirmClose = () => {
    this.setState({
      resetAgrees: true,
      isReagreeWaiverConfirmShow: false,
    })
    const { initKeycloak } = this.props
    initKeycloak(this.onUserSigninDone)
  }

  handleCancel = () => {
    this.setState({
      isReagreeWaiverConfirmShow: false,
    }, () => {
      this.reagreeWaiverTimer = setTimeout(() => {
        this.setState({
          isReagreeWaiverShow: true,
        })
      }, 500)
    })
  }

  handleGrantPermissionClose = () => {
    this.setState({
      isGrantPermissionShow: false,
    })
  }

  handleGrantPermissionSubmit = params => {
    const { authWithKeycloak, actions: { keycloakSigninCallback } } = this.props

    if (keycloakSigninCallback || authWithKeycloak) {
      this.handleIdpSubmit(params)
    } else if (params.buttonId === 'allow') {
      const { fields: { accountname, pawd } } = this.state
      this.handleSubmit({
        accountname,
        pawd,
        'permissions[]': 'PROFILE',
      })
    } else {
      this.handleGrantPermissionClose()
    }
  }

  handleRememberCheckboxChange = e => {
    this.setState({
      remember: e.target.checked,
    })
  }

  handlePasswordExpired = ({ isResetTokenSend, username: sentEmail }) => {
    const {
      processes: { forgotPassword, signIn }, username, sentEmailGoBack, existingAccount, usernameReadonly,
    } = this.props
    const { account, newUserName } = this.state

    // For forgot password then back. If sign in with existing account, keep username. If new account, remove username
    const usernameOb = (existingAccount || (username && usernameReadonly)) ? merge({
      username: username || account,
    }, { username: newUserName }) : { username: '' }

    const goBack = props => signIn(merge(
      this.props,
      props,
      usernameOb,
    ))

    forgotPassword({
      showNoticeOnly: true,
      sentEmail,
      sentEmailGoBack: sentEmailGoBack || goBack,
      messageContent: isResetTokenSend ? 'passport.forgotPwd.notice.haveSentEmailTo' : 'passport.expired.notice.error',
      hideEmail: !isResetTokenSend,
    })
  }

  handleForgotPawd = () => {
    const {
      processes: { forgotPassword, signIn }, username, sentEmailGoBack, existingAccount, usernameReadonly,
    } = this.props
    const { account, newUserName } = this.state

    // For forgot password then back. If sign in with existing account, keep username. If new account, remove username
    const usernameOb = (existingAccount || (username && usernameReadonly)) ? merge({
      username: username || account,
    }, { username: newUserName }) : { username: '' }

    const goBack = props => signIn(merge(
      this.props,
      props,
      usernameOb,
    ))

    forgotPassword({
      goBack,
      sentEmailGoBack: sentEmailGoBack || goBack,
      fields: { email: username },
      username,
      usernameReadonly: existingAccount,
    })
  }

  handleUserNameBlur = ({ target: { value } }) => {
    this.setState({
      newUserName: value,
    })
  }

  handleFacebookCreateAccount = facebookCreateAccountConfig => this.setSwitchConfig({ facebookCreateAccountConfig })

  handleFacebookBindAccount = facebookBindAccountConfig => this.setSwitchConfig({ facebookBindAccountConfig })

  handleMFAV2Operation = params => {
    const { onKeycloakSubmit,initKeycloak } = this.props
    const { fields: { accountname, pawd }, mfaMessageContent } = this.state
    if (mfaMessageContent) {
      // Ensure error message show when content didn't changed after action.
      this.setState({ mfaMessageContent: '' })
    }
    if (params.operation === mfaConfig.Operations.CLOSE) {
      const timer = setTimeout(() => {
        clearTimeout(timer)
        this.setState({
          isShowMFAV2: false,
        })
      }, 300)
      onKeycloakSubmit(params).then(result => {
         initKeycloak(this.onUserSigninDone)
      })
    } else if (params.operation === mfaConfig.Operations.RESENDCODE) {
      showSpinner()
      onKeycloakSubmit(params).then(({ nextTimeWindow, messageContent, messageType }) => {
        this.setState({
          nextTimeWindow,
          mfaMessageContent: messageContent,
          mfaMessageType: messageType,
        })
      }).finally(hideSpinner)
    } else {
      showSpinner()
      onKeycloakSubmit(params).then(result => {
        this.onUserSigninDone(this.state, { accountname, pawd })(result)
      }).finally(hideSpinner)
    }
  }

  goV5Signup = () => {
    const {
      registrationUrl,
      processes: { signUp },
    } = this.props
    if (!registrationUrl) {
      signUp()
    } else {
      showSpinner()
      window.location.href = registrationUrl
    }
  }

  render() {
    const {
      i18n,
      goBack,
      existingAccount, Header, username,
      authWithKeycloak, actions: { keycloakSigninCallback }, keycloakInitialized, alreadySignIn,
      initError, messageType, renderModel, configureTrack,
      clientConfig: {
        signinOptions: signinOptionsForWidget = [{ name: 'ACTIVE', viewGroup: 'ACTIVE' }],
      },
      customPanelUrl,
      noRegist,
      signinOptions: signinOptionsForPage = [{ name: 'ACTIVE', viewGroup: 'ACTIVE' }],
      locale,
    } = this.props

    const {
      facebookCreateAccountConfig, facebookBindAccountConfig, passwordUpdaterResult, coppaEmailResult,
      isBack, accountCountryCode, resetAgrees, showError, errorMsg, remember, clientName, fields,
      fields: { accountname: fieldUserName }, account, newUserName, nextTimeWindow, senderPhone, channel,
      otpSendCodeError, epid, isTrustDevice,
      isPasswordUpdaterShow, isCountryChooseShow, isGrantPermissionShow, isReagreeWaiverShow,
      isReagreeWaiverConfirmShow, isVerificationShow, isShowMFAV2, isPhoneAuthenticationShow,
      isReviewProfileShow, isLinkAccountShow, idpValues, kcMessageType, kcErrorMessage, identityProviderAlias,
      stepMode, mfaMessageContent, mfaMessageType, isShowBackBtnForMfaStepTwo, defaultWayForMfaStepOne,
    } = this.state

    const initialized = !authWithKeycloak || (keycloakInitialized || alreadySignIn || !!keycloakSigninCallback)
    if (coppaEmailResult.showCoppaEmailInput) {
      return (
        <CoppaEmailInput Header={Header} {...coppaEmailResult} {...this.props} />
      )
    }

    if (facebookCreateAccountConfig) {
      return (
        <FacebookCreateAccount {...facebookCreateAccountConfig} {...this.props} />
      )
    } if (facebookBindAccountConfig) {
      return (
        <FacebookBindAccount
          handleReturn={() => this.setState({ facebookBindAccountConfig: null })}
          {...facebookBindAccountConfig}
          {...this.props}
        />
      )
    }

    const userNameDisplay = newUserName || fieldUserName || username || account
    const isPageModel = renderModel === 'PAGE_RENDER'
    const signinOptions = (!isPageModel ? signinOptionsForWidget : signinOptionsForPage) || []
    const activeData = find(signinOptions, { name: 'ACTIVE' })
    const isShowActiveModel = !authWithKeycloak || (!!activeData && !alreadySignIn) // Support v4 and v5(widget && page)
    const isForceRequireAction = authWithKeycloak && !isPageModel && alreadySignIn
    const isShowRightSlotIframe = !!customPanelUrl

    const isNoRegist = noRegist === 'true'
    const isShowJoinNow = isNoRegist ? false : !existingAccount
    const isShowSigninWithContent = isNoRegist ? false : !existingAccount

    return (
      <div
        className={classNames(
          {
            passport__signin__wrapper: isShowRightSlotIframe,
          },
        )}
      >
        <DefaultComponentLayout className="DefaultComponentLayout" messageType={messageType} errMsg={initError} nameSpace="passport__signin" Header={isShowActiveModel && Header}>
          {isShowActiveModel && <LayoutContent title message="passport.signin.title" />}
          {initialized && (
            <LayoutContent main>
              <div className={`${isForceRequireAction ? 'already_sign_in' : ''}`}>
                {isPasswordUpdaterShow && (
                  <PasswordUpdater
                    isForceRequireAction={isForceRequireAction}
                    isPasswordUpdaterShow={isPasswordUpdaterShow}
                    passwordUpdaterResult={passwordUpdaterResult}
                    handlePasswordUpdaterModalClose={this.handlePasswordUpdaterModalClose}
                    handlePasswordUpdaterSubmit={this.handlePasswordUpdaterSubmit}
                    username={userNameDisplay}
                  />
                )}
                {isCountryChooseShow && (
                  <CountryChoose
                    isForceRequireAction={isForceRequireAction}
                    isCountryChooseShow={isCountryChooseShow}
                    handleChangeCountry={this.handleChangeCountry}
                    handleCountryChooseModalClose={this.handleCountryChooseModalClose}
                    handleCountryChooseSubmit={this.handleCountryChooseSubmit}
                  />
                )}
                {isReagreeWaiverShow && (
                  <ReagreeWaiver
                    isBack={isBack}
                    isForceRequireAction={isForceRequireAction}
                    selectedCountryCode={accountCountryCode}
                    isReagreeWaiverShow={isReagreeWaiverShow}
                    handleReagreeWaiverClose={this.handleReagreeWaiverClose}
                    handleReagreeWaiverSubmit={this.handleReagreeWaiverSubmit}
                    handleBack={this.handleBack}
                    resetAgrees={resetAgrees}
                    handleReagreeWaiverCheckboxChange={this.handleReagreeWaiverCheckboxChange}
                    {...this.props}
                  />
                )}
                {isReagreeWaiverConfirmShow && (
                  <ReagreeWaiverConfirm
                    handleCancel={this.handleCancel}
                    handleReagreeWaiverConfirmClose={this.handleReagreeWaiverConfirmClose}
                    isReagreeWaiverConfirmShow={isReagreeWaiverConfirmShow}
                    errorMsg={errorMsg}
                  />
                )}
                {isGrantPermissionShow && (
                  <GrantPermission
                    handleGrantPermissionClose={this.handleGrantPermissionClose}
                    handleGrantPermissionSubmit={this.handleGrantPermissionSubmit}
                    {...this.props}
                    clientName={clientName}
                    isGrantPermissionShow={isGrantPermissionShow}
                  />
                )}
                {isVerificationShow && (
                  <Verification
                    onClose={this.handleVerificationClose}
                    onRequestCode={this.handleVerificationRequestCode}
                    onVerify={this.handleVerificationVerify}
                    senderEmail={userNameDisplay}
                    senderPhone={senderPhone}
                    nextTimeWindow={nextTimeWindow}
                    message={otpSendCodeError}
                    configureTrack={configureTrack}
                    epid={epid}
                    channel={channel}
                  />
                )}
                {isShowMFAV2 && (
                  <MFAV2ByStep
                    messageType={mfaMessageType || 'error'}
                    messageContent={mfaMessageContent}
                    senderEmail={userNameDisplay}
                    senderPhone={senderPhone}
                    isTrustDevice={isTrustDevice}
                    nextTimeWindow={nextTimeWindow}
                    locale={locale}
                    handleOperation={this.handleMFAV2Operation}
                    stepMode={stepMode}
                    defaultWay={defaultWayForMfaStepOne}
                    channel={channel}
                    isShowBackBtn={isShowBackBtnForMfaStepTwo}
                  />
                )}
                {isPhoneAuthenticationShow && (
                  <PhoneAuthenticationByStep
                    onSetUpPhone={this.handleSetUpPhone}
                    configureTrack={configureTrack}
                    epid={epid}
                    locale={locale}
                    senderPhone={senderPhone}
                    nextTimeWindow={nextTimeWindow}
                    stepMode={stepMode}
                  />
                )}
                {isReviewProfileShow && (
                  <ReviewProfileModal
                    {...this.props}
                    kcMessageType={kcMessageType}
                    kcErrorMessage={kcErrorMessage}
                    idpValues={idpValues}
                    isReviewProfileShow={isReviewProfileShow}
                    handleReviewProfileModalClose={this.handleIdpModalCloseBuilder('isReviewProfileShow')}
                    handleReviewProfileSubmit={this.handleIdpSubmit}
                    cleanState={this.cleanState}
                  />
                )}
                {isLinkAccountShow && (
                  <LinkAccount
                    {...this.props}
                    identityProviderAlias={identityProviderAlias}
                    kcMessageType={kcMessageType}
                    kcErrorMessage={kcErrorMessage}
                    email={idpValues.email}
                    isLinkAccountShow={isLinkAccountShow}
                    handleLinkAccountClose={this.handleIdpModalCloseBuilder('isLinkAccountShow')}
                    handleLinkAccountSubmit={this.handleIdpSubmit}
                    cleanState={this.cleanState}
                  />
                )}
              </div>

              {isShowActiveModel && (
                <Identity>
                  <SigninForm
                    {...this.props}
                    showError={showError}
                    errorMsg={errorMsg}
                    remember={remember}
                    fields={fields}
                    username={username || account}
                    onSubmit={this.handleSubmit}
                    onRememberCheckboxChange={this.handleRememberCheckboxChange}
                    onForgotPawd={this.handleForgotPawd}
                    onUserNameBlur={this.handleUserNameBlur}
                  />

                  {isShowJoinNow && (
                    <div className="passport__signin__no-account">
                      <span className="passport__signin__no-account__text">
                        <I18nMessage id="passport.signin.notice.noAccount" />
                      </span>
                      <Link
                        tabIndex={0}
                        className="passport__pl5 passport__signin__no-account__join-now"
                        onClick={this.goV5Signup}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            this.goV5Signup()
                          }
                        }}
                      >
                        <I18nMessage id="passport.signin.notice.joinNow" />
                      </Link>
                    </div>
                  )}
                  {existingAccount && (
                    <Button aria-label={i18n('passport.common.btn.back')} onClick={goBack} type="secondary" className="passport__signin__button">
                      <I18nMessage id="passport.common.btn.back" />
                    </Button>
                  )}
                </Identity>
              )}
              {isShowSigninWithContent && (
                <SigninWithContent
                  {...this.props}
                  handleFacebookCreateAccount={this.handleFacebookCreateAccount}
                  handleFacebookBindAccount={this.handleFacebookBindAccount}
                  handleShowCoppaEmail={handleShowCoppaEmail}
                  onIdpSignin={this.onIdpSignin}
                />
              )}
            </LayoutContent>
          )}
        </DefaultComponentLayout>
        {
          isShowRightSlotIframe && (
            <div className="custom-frame">
              <iframe
                id="custom-frame"
                src={customPanelUrl}
                scrolling="no"
                name="custom-frame"
                title="custom frame"
              />
            </div>
          )
        }
      </div>
    )
  }
}

export default withI18n(connectLocale(withKeycloak(Signin,"Signin")))
